import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../store'
import { setErrors } from '../common/errorsSlice'
import { partition, sortBy } from 'lodash'
import iconv = require('iconv-lite')

import {
  RequestDeleteTaskApprovalGroup,
  RequestDeleteTaskBulkLabeling,
  RequestDeleteTaskExcludeAutoLabelingTask,
  RequestDeleteTaskExcludeGenerateMemberSetting,
  RequestDeleteTaskLabelGroupCategory,
  RequestDeleteTaskLabeling,
  RequestDeleteTaskLabelMasterSetting,
  RequestDeleteTaskLabelSettingLabelGroup,
  RequestDeleteTaskManual,
  RequestDeleteTaskPermission,
  RequestDeleteTaskProjectTemplateSetting,
  RequestDeleteTaskSeparate,
  RequestDeleteTaskTargetServiceSetting,
  RequestGetTaskApprovalApplication,
  RequestGetTaskApprovalApplicationDetail,
  RequestGetTaskApprovalApplicationList,
  RequestGetTaskBulkLabeling,
  RequestGetTaskCompanyServiceNameEdit,
  RequestGetTaskCustomSearch,
  RequestGetTaskExportDetail,
  RequestGetTaskGanttChart,
  RequestGetTaskGanttChartDetail,
  RequestGetTaskLabelGroupCategoryLabelGroup,
  RequestGetTaskLabelGroupSummary,
  RequestGetTaskLabeling,
  RequestGetTaskLabelingStatus,
  RequestGetTaskLabelMasterSetting,
  RequestGetTaskLabelSetting,
  RequestGetTaskLabelSettingDetail,
  RequestGetTaskNotWorkingRange,
  RequestGetTaskProjectTemplateSetting,
  RequestGetTaskProjectTemplateSettingDetail,
  RequestGetTaskRecentlyUsedLabelGroup,
  RequestGetTaskReportLabelGroup,
  RequestGetTaskReportLabelGroupCategory,
  RequestGetTaskReportLabelGroupCategoryDetail,
  RequestGetTaskReportLabelGroupCategoryDetailMax,
  RequestGetTaskReportLabelGroupCategoryDetailSummary,
  RequestGetTaskReportLabelGroupDetail,
  RequestGetTaskReportLabelGroupDetailMax,
  RequestGetTaskReportLabelGroupDetailSummary,
  RequestGetTaskReportMember,
  RequestGetTaskReportTeam,
  RequestGetTaskSearch,
  RequestGetTaskSearchLabelGroup,
  RequestGetTaskViewableLabelGroup,
  RequestGetTaskViewableLabelGroupDetail,
  RequestGetTaskViewableLabelGroupMember,
  RequestGetTaskViewableLabelGroupTeam,
  RequestPatchTaskApprovalGroup,
  RequestPatchTaskCompanyServiceName,
  RequestPatchTaskCostSetting,
  RequestPatchTaskDisplayCreateManualTaskSetting,
  RequestPatchTaskLabel,
  RequestPatchTaskLabelGroupCategory,
  RequestPatchTaskLabelGroupOrder,
  RequestPatchTaskLabeling,
  RequestPatchTaskLabelingTargetModeSetting,
  RequestPatchTaskLabelMasterSetting,
  RequestPatchTaskLabelMember,
  RequestPatchTaskLabelSettingLabelGroup,
  RequestPatchTaskLabelSettingTeamLabelRelationTmp,
  RequestPatchTaskLearningScopeSetting,
  RequestPatchTaskNotWorkingRange,
  RequestPatchTaskOverwriteBreakTimeSetting,
  RequestPatchTaskPermission,
  RequestPatchTaskProjectTemplateSetting,
  RequestPatchTaskReportLabelGroupDetailSummary,
  RequestPatchTaskThresholdSetting,
  RequestPostTaskApprovalApplication,
  RequestPostTaskApprovalGroup,
  RequestPostTaskBulkLabeling,
  RequestPostTaskCostSetting,
  RequestPostTaskExcludeAutoLabelingTask,
  RequestPostTaskExcludeGenerateMemberSetting,
  RequestPostTaskExportDetail,
  RequestPostTaskLabelGroupCategory,
  RequestPostTaskLabelGroupImport,
  RequestPostTaskLabeling,
  RequestPostTaskLabelingPre,
  RequestPostTaskLabelMasterImport,
  RequestPostTaskLabelMasterSetting,
  RequestPostTaskLabelSettingLabelGroup,
  RequestPostTaskManual,
  RequestPostTaskPermission,
  RequestPostTaskProjectTemplateSetting,
  RequestPostTaskSeparate,
  RequestPostTaskTargetServiceSetting,
  ResponseDeleteTaskManual,
  ResponseDeleteTaskSeparate,
  ResponseGetTaskApprovalApplication,
  ResponseGetTaskApprovalApplicationDetail,
  ResponseGetTaskApprovalApplicationList,
  ResponseGetTaskApprovalGroup,
  ResponseGetTaskBulkLabeling,
  ResponseGetTaskBulkLabelingNew,
  ResponseGetTaskCompanyServiceName,
  ResponseGetTaskCompanyServiceNameEdit,
  ResponseGetTaskCostSetting,
  ResponseGetTaskCustomSearch,
  ResponseGetTaskCustomSearchNew,
  ResponseGetTaskDisplayCreateManualTaskSetting,
  ResponseGetTaskExcludeGenerateMemberSetting,
  ResponseGetTaskExportList,
  ResponseGetTaskGanttChart,
  ResponseGetTaskGanttChartDetail,
  ResponseGetTaskGanttChartList,
  ResponseGetTaskLabelGroupCategory,
  ResponseGetTaskLabelGroupCategoryLabelGroup,
  ResponseGetTaskLabelGroupOrder,
  ResponseGetTaskLabelGroupSummary,
  ResponseGetTaskLabeling,
  ResponseGetTaskLabelingStatus,
  ResponseGetTaskLabelingTargetModeSetting,
  ResponseGetTaskLabelMasterSetting,
  ResponseGetTaskLabelSetting,
  ResponseGetTaskLabelSettingDetail,
  ResponseGetTaskLabelSettingNewDetail,
  ResponseGetTaskLearningScopeSetting,
  ResponseGetTaskNotWorkingRange,
  ResponseGetTaskOverwriteBreakTimeSetting,
  ResponseGetTaskPermission,
  ResponseGetTaskProjectTemplateSetting,
  ResponseGetTaskProjectTemplateSettingDetail,
  ResponseGetTaskProjectTemplateSettingNewDetail,
  ResponseGetTaskRecentlyUsedLabelGroup,
  ResponseGetTaskReportLabelGroup,
  ResponseGetTaskReportLabelGroupCategory,
  ResponseGetTaskReportLabelGroupCategoryDetail,
  ResponseGetTaskReportLabelGroupCategoryDetailMax,
  ResponseGetTaskReportLabelGroupCategoryDetailSummary,
  ResponseGetTaskReportLabelGroupDetail,
  ResponseGetTaskReportLabelGroupDetailMax,
  ResponseGetTaskReportLabelGroupDetailSummary,
  ResponseGetTaskReportMember,
  ResponseGetTaskReportTeam,
  ResponseGetTaskSearch,
  ResponseGetTaskSearchLabelGroup,
  ResponseGetTaskSearchNew,
  ResponseGetTaskTargetServiceSetting,
  ResponseGetTaskThresholdSetting,
  ResponseGetTaskViewableLabelGroup,
  ResponseGetTaskViewableLabelGroupDetail,
  ResponseGetTaskViewableLabelGroupMember,
  ResponseGetTaskViewableLabelGroupTeam,
  ResponsePostTaskApprovalGroup,
  ResponsePostTaskCostSetting,
  ResponsePostTaskExcludeAutoLabelingTask,
  ResponsePostTaskLabelGroupCategory,
  ResponsePostTaskLabelGroupImport,
  ResponsePostTaskLabelMasterImport,
  ResponsePostTaskLabelMasterSetting,
  ResponsePostTaskLabelSettingLabelGroup,
  ResponsePostTaskManual,
  ResponsePostTaskPermission,
  ResponsePostTaskProjectTemplateSetting,
  ResponsePostTaskSeparate,
  ResponsePostTaskTargetServiceSetting,
  TaskBulkLabeling,
  TaskCustomSearch,
  TaskSearch,
} from '../../types/task'
import {
  deleteTaskApprovalGroup,
  deleteTaskExcludeGenerateMemberSetting,
  deleteTaskLabelGroupCategory,
  deleteTaskLabeling,
  deleteTaskLabelMasterSetting,
  deleteTaskLabelSettingLabelGroup,
  deleteTaskManual,
  deleteTaskPermission,
  deleteTaskProjectTemplateSetting,
  deleteTaskSeparate,
  deleteTaskTargetServiceSetting,
  getTaskApprovalApplication,
  getTaskApprovalApplicationDetail,
  getTaskApprovalGroup,
  getTaskCostSetting,
  getTaskCustomSearch,
  getTaskCustomSearchNew,
  getTaskExcludeGenerateMemberSetting,
  getTaskExportDetail,
  getTaskExportList,
  getTaskGanttChartList,
  getTaskGanttChart,
  getTaskLabelGroupCategory,
  getTaskLabeling,
  getTaskLabelingStatus,
  getTaskLabelMasterSetting,
  getTaskLabelSetting,
  getTaskLabelSettingDetail,
  getTaskLabelSettingNewDetail,
  getTaskOverwriteBreakTimeSetting,
  getTaskPermission,
  getTaskProjectTemplateSetting,
  getTaskProjectTemplateSettingDetail,
  getTaskProjectTemplateSettingNewDetail,
  getTaskReportLabelGroup,
  getTaskReportLabelGroupCategory,
  getTaskReportLabelGroupCategoryDetail,
  getTaskReportLabelGroupCategoryDetailMax,
  getTaskReportLabelGroupCategoryDetailSummary,
  getTaskReportLabelGroupDetail,
  getTaskReportLabelGroupDetailMax,
  getTaskReportLabelGroupDetailSummary,
  getTaskReportMember,
  getTaskReportTeam,
  getTaskSearch,
  getTaskSearchNew,
  getTaskTargetServiceSetting,
  getTaskThresholdSetting,
  patchTaskApprovalGroup,
  patchTaskCostSetting,
  patchTaskLabelGroupCategory,
  patchTaskLabeling,
  patchTaskLabelMasterSetting,
  patchTaskLabelSettingLabelGroup,
  patchTaskLabelSettingTeamLabelRelation,
  patchTaskOverwriteBreakTimeSetting,
  patchTaskPermission,
  patchTaskProjectTemplateSetting,
  patchTaskReportLabelGroupDetailSummary,
  patchTaskThresholdSetting,
  postTaskApprovalApplication,
  postTaskApprovalGroup,
  postTaskCostSetting,
  postTaskExcludeGenerateMemberSetting,
  postTaskExportDetail,
  postTaskLabelGroupCategory,
  postTaskLabelGroupImport,
  postTaskLabeling,
  postTaskLabelMasterSetting,
  postTaskLabelSettingLabelGroup,
  postTaskManual,
  postTaskPermission,
  postTaskProjectTemplateSetting,
  postTaskSeparate,
  postTaskTargetServiceSetting,
  getTaskGanttChartDetail,
  patchTaskLabel,
  patchTaskLabelMember,
  postTaskExcludeAutoLabelingTask,
  deleteTaskExcludeAutoLabelingTask,
  postTaskLabelMasterImport,
  patchTaskLabelGroupOrder,
  getTaskLabelGroupOrder,
  getTaskLearningScopeSetting,
  patchTaskLearningScopeSetting,
  getTaskDisplayCreateManualTaskSetting,
  patchTaskDisplayCreateManualTaskSetting,
  getTaskLabelingTargetModeSetting,
  patchTaskLabelingTargetModeSetting,
  getTaskCompanyServiceName,
  getTaskCompanyServiceNameEdit,
  patchTaskCompanyServiceName,
  getImportCsv,
  getTaskBulkLabeling,
  postTaskBulkLabeling,
  deleteTaskBulkLabeling,
  getTaskBulkLabelingNew,
  getTaskApprovalApplicationList,
  getTaskNotWorkingRange,
  patchTaskNotWorkingRange,
  getTaskSearchLabelGroup,
  getTaskRecentlyUsedLabelGroup,
  getTaskLabelGroupCategoryLabelGroup,
  getTaskViewableLabelGroup,
  getTaskViewableLabelGroupDetail,
  getTaskViewableLabelGroupMember,
  getTaskViewableLabelGroupTeam,
  getTaskLabelGroupSummary,
} from '../../apis/task'
import { dateToTodayElapsedSeconds, format, nowDate } from '../../../utils/date'
import { fetchAccessToken } from '../auth/loginSlice'

interface State {
  isLoading: boolean
  isLoadingForModal: boolean
  taskLabeling: ResponseGetTaskLabeling
  taskLabelingStatus: ResponseGetTaskLabelingStatus
  taskLabelSetting: ResponseGetTaskLabelSetting
  taskLabelSettingDetail: ResponseGetTaskLabelSettingDetail
  taskTargetServiceSetting: ResponseGetTaskTargetServiceSetting
  taskLabelMasterSetting: ResponseGetTaskLabelMasterSetting
  taskReportLabelGroup: ResponseGetTaskReportLabelGroup
  taskReportLabelGroupDetail: ResponseGetTaskReportLabelGroupDetail
  taskReportLabelGroupDetailMax: ResponseGetTaskReportLabelGroupDetailMax
  taskReportLabelGroupDetailSummary: ResponseGetTaskReportLabelGroupDetailSummary
  taskExport: ResponseGetTaskExportList
  taskPermission: ResponseGetTaskPermission
  taskCostSetting: ResponseGetTaskCostSetting
  taskSearch: TaskSearch
  taskThresholdSetting: ResponseGetTaskThresholdSetting
  taskDisplayCreateManualTaskSetting: ResponseGetTaskDisplayCreateManualTaskSetting
  taskOverwriteBreakTimeSetting: ResponseGetTaskOverwriteBreakTimeSetting
  taskReportMember: ResponseGetTaskReportMember
  taskReportTeam: ResponseGetTaskReportTeam
  taskProjectTemplateSetting: ResponseGetTaskProjectTemplateSetting
  taskProjectTemplateSettingDetail: ResponseGetTaskProjectTemplateSettingDetail
  taskApprovalGroup: ResponseGetTaskApprovalGroup
  taskApprovalApplicationList: ResponseGetTaskApprovalApplicationList
  taskApprovalApplication: ResponseGetTaskApprovalApplication
  taskApprovalApplicationDetail: ResponseGetTaskApprovalApplicationDetail
  taskExcludeGenerateMemberSetting: ResponseGetTaskExcludeGenerateMemberSetting
  taskLabelGroupCategory: ResponseGetTaskLabelGroupCategory
  taskReportLabelGroupCategory: ResponseGetTaskReportLabelGroupCategory
  taskReportLabelGroupCategoryDetail: ResponseGetTaskReportLabelGroupCategoryDetail
  taskReportLabelGroupCategoryDetailMax: ResponseGetTaskReportLabelGroupCategoryDetailMax
  taskReportLabelGroupCategoryDetailSummary: ResponseGetTaskReportLabelGroupCategoryDetailSummary
  taskLabelGroupImport: ResponsePostTaskLabelGroupImport
  taskCustomSearch: TaskCustomSearch
  taskGanttChartList: ResponseGetTaskGanttChartList
  taskGanttCharts: ResponseGetTaskGanttChart[]
  taskGanttChartDetail: ResponseGetTaskGanttChartDetail
  taskLabelMasterImport: ResponsePostTaskLabelMasterImport
  taskLabelGroupOrder: ResponseGetTaskLabelGroupOrder
  taskLearningScopeSetting: ResponseGetTaskLearningScopeSetting
  taskLabelingTargetModeSetting: ResponseGetTaskLabelingTargetModeSetting
  taskCompanyServiceName: ResponseGetTaskCompanyServiceName
  taskBulkLabeling: TaskBulkLabeling
  taskNotWorkingRange: ResponseGetTaskNotWorkingRange
  taskSearchLabelGroup: ResponseGetTaskSearchLabelGroup
  taskRecentlyUsedLabelGroup: ResponseGetTaskRecentlyUsedLabelGroup
}

const initialState: Partial<State> = {
  isLoading: true,
  isLoadingForModal: false,
  taskLabeling: undefined,
  taskLabelingStatus: undefined,
  taskLabelSetting: undefined,
  taskLabelSettingDetail: undefined,
  taskTargetServiceSetting: undefined,
  taskLabelMasterSetting: undefined,
  taskReportLabelGroup: undefined,
  taskReportLabelGroupDetail: undefined,
  taskReportLabelGroupDetailMax: undefined,
  taskReportLabelGroupDetailSummary: undefined,
  taskExport: undefined,
  taskPermission: undefined,
  taskCostSetting: undefined,
  taskSearch: undefined,
  taskThresholdSetting: undefined,
  taskReportMember: undefined,
  taskReportTeam: undefined,
  taskProjectTemplateSetting: undefined,
  taskProjectTemplateSettingDetail: undefined,
  taskApprovalGroup: undefined,
  taskApprovalApplicationList: undefined,
  taskApprovalApplication: undefined,
  taskApprovalApplicationDetail: undefined,
  taskExcludeGenerateMemberSetting: undefined,
  taskLabelGroupCategory: undefined,
  taskReportLabelGroupCategory: undefined,
  taskReportLabelGroupCategoryDetail: undefined,
  taskReportLabelGroupCategoryDetailMax: undefined,
  taskReportLabelGroupCategoryDetailSummary: undefined,
  taskLabelGroupImport: undefined,
  taskGanttChartList: undefined,
  taskGanttCharts: [],
  taskGanttChartDetail: undefined,
  taskLabelMasterImport: undefined,
  taskLabelGroupOrder: undefined,
  taskLearningScopeSetting: undefined,
  taskLabelingTargetModeSetting: undefined,
  taskCompanyServiceName: undefined,
  taskBulkLabeling: undefined,
  taskNotWorkingRange: undefined,
  taskSearchLabelGroup: undefined,
  taskRecentlyUsedLabelGroup: undefined,
}

const RESERVED_LABEL_GROUP_ID = 2

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    requestStartForModal: (state) => {
      state.isLoadingForModal = true
      return state
    },
    buildTaskLabeling: (state, action: PayloadAction<ResponseGetTaskLabeling>) => {
      state.isLoading = false
      state.taskLabeling = action.payload
      state.taskLabeling.tasks = state.taskLabeling.tasks.map((v) => ({ ...v, is_loading: false }))
      return state
    },
    changeTaskLabelingStart: (state, action: PayloadAction<{ task_ids: number[] }>) => {
      if (!state.taskLabeling) return state
      state.taskLabeling.tasks = state.taskLabeling.tasks.map((v) => (action.payload.task_ids.includes(v.task_id) ? ({ ...v, is_loading: true }) : v))
      return state
    },
    changeTaskLabelingStatus: (state, action: PayloadAction<{ status: string }>) => {
      if (!state.taskLabeling) return state
      state.taskLabeling.approval_status = action.payload.status
      return state
    },
    addTaskLabeling: (state, action: PayloadAction<RequestPostTaskLabelingPre>) => {
      state.isLoading = false
      if (!state.taskLabeling) return state
      if (action.payload.label.id <= RESERVED_LABEL_GROUP_ID) {
        const buildLabel = (labelId: number) => {
          if (labelId === 1) {
            return (
              {
                label_group_name: "休憩",
                label_group_color: "#FFA26B",
                label_name: "休憩",
                label_color: "#FFA26B",
              }
            )
          }
          if (labelId === 2) {
            return (
              {
                label_group_name: "業務外",
                label_group_color: "#666666",
                label_name: "業務外",
                label_color: "#666666",
              }
            )
          }
          return (
            {
              label_group_name: "プロジェクトに属さない作業データ",
              label_group_color: "#339BB2",
              label_name: "プロジェクトに属さない作業データ",
              label_color: "#339BB2",
            }
          )
        }
        state.taskLabeling.tasks = state.taskLabeling?.tasks.map((task) => (
          action.payload.task_ids.includes(task.task_id)
            ? { ...task,
              label: {
                label_group_id: action.payload.label_group.id,
                label_group_name: buildLabel(action.payload.label_group.id).label_group_name,
                label_group_color: buildLabel(action.payload.label_group.id).label_group_color,
                label_group_code: null,
                label_id: action.payload.label.id,
                label_name: buildLabel(action.payload.label_group.id).label_name,
                label_color: buildLabel(action.payload.label_group.id).label_color,
                label_code: null,
                disabled: false,
                status: "manual",
              },
              is_loading: false,
            }
            : task
        ))
        return state
      }
      state.taskLabeling.tasks = state.taskLabeling?.tasks.map((task) => (
        action.payload.task_ids.includes(task.task_id)
          ? { ...task,
            label: {
              label_group_id: action.payload.label_group.id,
              label_group_name: action.payload.label_group.name,
              label_group_color: action.payload.label_group.color,
              label_group_code: action.payload.label_group.code,
              label_id: action.payload.label.id,
              label_name: action.payload.label.name,
              label_color: action.payload.label.color,
              label_code: action.payload.label.code,
              disabled: false,
              status: "manual",
            },
            is_loading: false,
          }
          : task
      ))
      return state
    },
    modTaskLabeling: (state, action: PayloadAction<RequestPatchTaskLabeling>) => {
      state.isLoading = false
      if (!state.taskLabeling) return state
      state.taskLabeling.tasks = state.taskLabeling?.tasks.map((task) => (
        task.task_id === action.payload.task_id
          ? { ...task, task_name: action.payload.task_name, is_loading: false } : task
      ))
      return state
    },
    delTaskLabeling: (state, action: PayloadAction<RequestDeleteTaskLabeling>) => {
      state.isLoading = false
      if (!state.taskLabeling) return state
      state.taskLabeling.tasks = state.taskLabeling?.tasks.map((task) => (
        action.payload.task_ids.includes(task.task_id)
          ? { ...task, label: null, is_loading: false }
          : task
      ))
      return state
    },
    addTaskManual: (state, action: PayloadAction<ResponsePostTaskManual>) => {
      state.isLoading = false
      if (!state.taskLabeling) return state
      state.taskLabeling.tasks = [
        ...state.taskLabeling?.tasks,
        { ...action.payload, is_loading: false },
      ].sort((a, b) => (
        dateToTodayElapsedSeconds(a.timeline[0].start_time, format(action.payload.work_start_time, "YYYY-MM-DD"))
        - dateToTodayElapsedSeconds(b.timeline[0].start_time, format(action.payload.work_start_time, "YYYY-MM-DD"))
      ))
      state.taskLabeling.work_start_time = action.payload.work_start_time
      state.taskLabeling.work_end_time = action.payload.work_end_time
      return state
    },
    delTaskManual: (state, action: PayloadAction<{param: RequestDeleteTaskManual, result: ResponseDeleteTaskManual}>) => {
      state.isLoading = false
      if (!state.taskLabeling) return state
      state.taskLabeling.tasks = state.taskLabeling?.tasks.filter((task) => task.task_id !== action.payload.param.id)
      state.taskLabeling.work_start_time = action.payload.result.work_start_time
      state.taskLabeling.work_end_time = action.payload.result.work_end_time
      return state
    },
    buildTaskTargetServiceSetting: (state, action: PayloadAction<ResponseGetTaskTargetServiceSetting>) => {
      state.isLoading = false
      state.taskTargetServiceSetting = action.payload
      return state
    },
    addTaskTargetServiceSetting: (state, action: PayloadAction<ResponsePostTaskTargetServiceSetting[]>) => {
      const tmp = action.payload.map((v) => v.service_name)
      state.isLoading = false
      if (state.taskTargetServiceSetting) {
        state.taskTargetServiceSetting.target_services = [
          ...state.taskTargetServiceSetting.target_services,
          ...action.payload,
        ]
        state.taskTargetServiceSetting.available_services = state.taskTargetServiceSetting.available_services.filter(
          (v) => !tmp.includes(v),
        )
      }
      if (state.taskTargetServiceSetting?.service_usages) {
        state.taskTargetServiceSetting.service_usages = state.taskTargetServiceSetting.service_usages.map(
          (v) => (
            {
              team_name: v.team_name,
              services: v.services.map((w) => {
                if (tmp.includes(w.name)) {
                  return (
                    {
                      name: w.name,
                      icon: w.icon,
                      icon_color: w.icon_color,
                      status: "registered_as_target",
                      time: w.time,
                      registered_datetime: nowDate("YYYY/MM/DD HH:mm"),
                    }
                  )
                }
                return w
              }),
            }
          ),
        )
      }
      if (state.taskTargetServiceSetting?.company_service_usages) {
        state.taskTargetServiceSetting.company_service_usages = {
          ...state.taskTargetServiceSetting.company_service_usages,
          services: state.taskTargetServiceSetting.company_service_usages.services.map(
            (v) => {
              if (tmp.includes(v.name)) {
                return (
                  {
                    name: v.name,
                    status: "registered_as_target",
                    time: v.time,
                    registered_datetime: nowDate("YYYY/MM/DD HH:mm"),
                  }
                )
              }
              return v
            },
          ),
        }
      }
      return state
    },
    delTaskTargetServiceSetting: (state, action: PayloadAction<RequestDeleteTaskTargetServiceSetting>) => {
      state.isLoading = false
      if (!state.taskTargetServiceSetting) return state
      state.taskTargetServiceSetting.available_services = [
        ...state.taskTargetServiceSetting.available_services,
        state.taskTargetServiceSetting.target_services.find((v) => (v.id === action.payload.id))?.service_name || "",
      ]
      state.taskTargetServiceSetting.service_usages = state.taskTargetServiceSetting.service_usages.map(
        (v) => (
          {
            team_name: v.team_name,
            services: v.services.map((w) => {
              if (w.name === (state.taskTargetServiceSetting?.target_services.find((x) => (x.id === action.payload.id))?.service_name || "")) {
                return (
                  {
                    name: w.name,
                    icon: w.icon,
                    icon_color: w.icon_color,
                    status: "registered_as_service",
                    time: w.time,
                    registered_datetime: null,
                  }
                )
              }
              return w
            }),
          }
        ),
      )
      state.taskTargetServiceSetting.company_service_usages = {
        ...state.taskTargetServiceSetting.company_service_usages,
        services: state.taskTargetServiceSetting.company_service_usages.services.map(
          (v) => {
            if (v.name === (state.taskTargetServiceSetting?.target_services.find((x) => (x.id === action.payload.id))?.service_name || "")) {
              return (
                {
                  name: v.name,
                  status: "registered_as_service",
                  time: v.time,
                  registered_datetime: null,
                }
              )
            }
            return v
          },
        ),
      }
      state.taskTargetServiceSetting.target_services = state.taskTargetServiceSetting.target_services.filter((v) => (
        v.id !== action.payload.id
      ))
      return state
    },
    buildTaskLabelMasterSetting: (state, action: PayloadAction<ResponseGetTaskLabelMasterSetting>) => {
      state.isLoading = false
      state.taskLabelMasterSetting = action.payload
      return state
    },
    addTaskLabelMasterSetting: (state, action: PayloadAction<ResponsePostTaskLabelMasterSetting>) => {
      state.isLoading = false
      if (!state.taskLabelMasterSetting) return state
      state.taskLabelMasterSetting.label_masters = [
        ...state.taskLabelMasterSetting.label_masters,
        {
          id: action.payload.id,
          name: action.payload.name,
          color: action.payload.color,
          created_at: action.payload.created_at,
          created_by: action.payload.created_by,
          label_group_ids: action.payload.label_group_ids,
          label_group_count: action.payload.label_group_count,
          description: action.payload.description,
        },
      ]
      return state
    },
    modTaskLabelMasterSetting: (state, action: PayloadAction<RequestPatchTaskLabelMasterSetting>) => {
      state.isLoading = false
      if (!state.taskLabelMasterSetting) return state
      state.taskLabelMasterSetting.label_masters = action.payload.disabled
        ? state.taskLabelMasterSetting.label_masters.filter((label_master) => label_master.id !== action.payload.label_master_id)
        : state.taskLabelMasterSetting.label_masters.map((label_master) => (
          label_master.id === action.payload.label_master_id
            ? {
              ...label_master,
              name: action.payload.name || label_master.name,
              color: action.payload.color || label_master.color,
              description: action.payload.description || label_master.description,
              label_group_ids: action.payload.label_group_ids || label_master.label_group_ids,
              label_group_count: action.payload.label_group_ids?.length || 0,
            }
            : label_master
        ))
      return state
    },
    delTaskLabelMasterSetting: (state, action: PayloadAction<RequestDeleteTaskLabelMasterSetting>) => {
      state.isLoading = false
      if (!state.taskLabelMasterSetting) return state
      state.taskLabelMasterSetting.label_masters = state.taskLabelMasterSetting.label_masters.filter((v) => (
        v.id !== action.payload.label_master_id
      ))
      return state
    },
    buildTaskLabelSetting: (state, action: PayloadAction<ResponseGetTaskLabelSetting>) => {
      state.isLoading = false
      state.taskLabelSetting = action.payload
      return state
    },
    buildTaskLabelSettingDetail: (state, action: PayloadAction<ResponseGetTaskLabelSettingDetail>) => {
      state.isLoading = false
      state.taskLabelSettingDetail = action.payload
      return state
    },
    buildTaskLabelSettingNewDetail: (state, action: PayloadAction<ResponseGetTaskLabelSettingNewDetail>) => {
      state.isLoading = false
      state.taskLabelSettingDetail = {
        label_group: undefined,
        target_services: action.payload.target_services,
        label_masters: action.payload.label_masters,
        teams: action.payload.teams,
        members: action.payload.members,
        label_group_names: action.payload.label_group_names,
      }
      return state
    },
    modTaskLabelSettingLabelGroup: (state, action: PayloadAction<RequestPatchTaskLabelSettingLabelGroup>) => {
      state.isLoading = false
      if (!state.taskLabelSetting) return state
      if (action.payload.disabled && action.payload.disable_status === "deleted") {
        state.taskLabelSetting.label_groups = state.taskLabelSetting.label_groups.filter((v) => v.id !== Number(action.payload.id))
        return state
      }
      state.taskLabelSetting.label_groups = state.taskLabelSetting.label_groups.map((label_group) => (
        label_group.id === Number(action.payload.id)
          ? {
            ...label_group,
            name: action.payload.name || label_group.name,
            code: action.payload.code !== undefined ? action.payload.code : label_group.code,
            color: action.payload.color || label_group.color,
            disabled: action.payload.disabled != null ? action.payload.disabled : label_group.disabled,
            scheduled_start_date: action.payload.scheduled_start_date || label_group.scheduled_start_date,
            scheduled_end_date: action.payload.scheduled_end_date !== undefined ? action.payload.scheduled_end_date : label_group.scheduled_end_date,
          }
          : label_group
      ))
      return state
    },
    delTaskLabelSettingLabelGroup: (state, action: PayloadAction<RequestDeleteTaskLabelSettingLabelGroup>) => {
      state.isLoading = false
      if (!state.taskLabelSetting) return state
      state.taskLabelSetting.label_groups = state.taskLabelSetting.label_groups.filter((label_group) => label_group.id !== Number(action.payload.id))
      return state
    },
    modTaskLabelSettingTeamLabelRelation: (state, action: PayloadAction<RequestPatchTaskLabelSettingTeamLabelRelationTmp>) => {
      state.isLoading = false
      if (!state.taskLabelSetting) return state
      state.taskLabelSetting.label_groups = state.taskLabelSetting.label_groups.map((label_group) => (
        label_group.id === Number(action.payload.label_group_id)
          ? {
            ...label_group,
            target_teams: action.payload.teams.map((team) => (
              { id: team.id, name: team.name }
            )),
          }
          : label_group
      ))
      return state
    },
    buildTaskLabelingStatus: (state, action: PayloadAction<ResponseGetTaskLabelingStatus>) => {
      state.isLoading = false
      state.taskLabelingStatus = action.payload
      return state
    },
    buildTaskReportLabelGroup: (state, action: PayloadAction<ResponseGetTaskReportLabelGroup>) => {
      state.isLoading = false
      state.taskReportLabelGroup = action.payload
      return state
    },
    buildTaskReportLabelGroupDetail: (state, action: PayloadAction<ResponseGetTaskReportLabelGroupDetail>) => {
      state.isLoading = false
      state.taskReportLabelGroupDetail = action.payload
      return state
    },
    buildTaskReportLabelGroupDetailMax: (state, action: PayloadAction<ResponseGetTaskReportLabelGroupDetailMax>) => {
      state.isLoading = false
      state.taskReportLabelGroupDetailMax = action.payload
      return state
    },
    buildTaskReportLabelGroupDetailSummary: (state, action: PayloadAction<ResponseGetTaskReportLabelGroupDetailSummary>) => {
      state.isLoading = false
      if (state.taskReportLabelGroupDetailSummary) {
        state.taskReportLabelGroupDetailSummary.months = [
          ...state.taskReportLabelGroupDetailSummary.months,
          ...action.payload.months,
        ].sort((a, b) => Number(format(a.date, "YYYYMM")) - Number(format(b.date, "YYYYMM")))
      } else {
        state.taskReportLabelGroupDetailSummary = action.payload
      }
      return state
    },
    modTaskReportLabelGroupDetailSummary: (state, action: PayloadAction<RequestPatchTaskReportLabelGroupDetailSummary>) => {
      state.isLoading = false
      if (state.taskReportLabelGroupDetailSummary) {
        state.taskReportLabelGroupDetailSummary.months = state.taskReportLabelGroupDetailSummary?.months.map((v) => {
          if (v.date === action.payload.target_date) {
            const tmp = { ...v }
            if (action.payload.accounting?.budget !== undefined) {
              tmp.accounting.budget = action.payload.accounting.budget
            }
            if (action.payload.accounting?.other_costs !== undefined) {
              tmp.accounting.other_costs = action.payload.accounting.other_costs
            }
            if (action.payload.labeling?.scheduled !== undefined) {
              tmp.labeling.scheduled = action.payload.labeling.scheduled
            }
            return tmp
          }
          return v
        }) || []
      }
      return state
    },
    initTaskReportLabelGroupDetailSummary: (state) => {
      state.isLoading = false
      if (state.taskReportLabelGroupDetailSummary) {
        state.taskReportLabelGroupDetailSummary.months = []
      }
      return state
    },
    buildTaskExportList: (state, action: PayloadAction<ResponseGetTaskExportList>) => {
      state.isLoading = false
      state.taskExport = action.payload
      return state
    },
    buildTaskPermission: (state, action: PayloadAction<ResponseGetTaskPermission>) => {
      state.isLoading = false
      state.taskPermission = action.payload
      return state
    },
    addTaskPermission: (state, action: PayloadAction<ResponsePostTaskPermission>) => {
      state.isLoading = false
      if (!state.taskPermission) return state
      state.taskPermission.members = [
        ...state.taskPermission.members,
        { ...action.payload },
      ]
      return state
    },
    modTaskPermission: (state, action: PayloadAction<RequestPatchTaskPermission>) => {
      state.isLoading = false
      if (!state.taskPermission) return state
      state.taskPermission.members = state.taskPermission.members.map((member) => (
        member.id === action.payload.id
          ? {
            ...member,
            project_setting: action.payload.project_setting || false,
            cost_view: action.payload.cost_view || false,
            member_cost_setting: action.payload.member_cost_setting || false,
            project_cost_setting: action.payload.project_cost_setting || false,
            attendance_export: action.payload.attendance_export || false,
            project_member_setting: action.payload.project_member_setting || false,
          }
          : member
      ))
      return state
    },
    delTaskPermission: (state, action: PayloadAction<RequestDeleteTaskPermission>) => {
      state.isLoading = false
      if (!state.taskPermission) return state
      state.taskPermission.members = state.taskPermission.members.filter((v) => (
        v.id !== action.payload.id
      ))
      return state
    },
    buildTaskCostSetting: (state, action: PayloadAction<ResponseGetTaskCostSetting>) => {
      state.isLoading = false
      state.taskCostSetting = action.payload
      return state
    },
    modTaskCostSetting: (state, action: PayloadAction<RequestPatchTaskCostSetting>) => {
      state.isLoading = false
      if (!state.taskCostSetting) return state
      state.taskCostSetting.members = state.taskCostSetting.members.map((member) => (
        member.id === action.payload.id
          ? {
            ...member,
            hourly_pay: action.payload.hourly_pay || null,
          }
          : member
      ))
      return state
    },
    buildTaskSearch: (state, action: PayloadAction<ResponseGetTaskSearch>) => {
      state.isLoading = false
      state.taskSearch = {
        tasks: action.payload.tasks || [],
        members: state.taskSearch?.members || [],
        teams: state.taskSearch?.teams || [],
        service_names: state.taskSearch?.service_names || [],
        label_groups: state.taskSearch?.label_groups || [],
        label_masters: state.taskSearch?.label_masters || [],
      }
      return state
    },
    buildTaskSearchNew: (state, action: PayloadAction<ResponseGetTaskSearchNew>) => {
      state.isLoading = false
      state.taskSearch = {
        tasks: state.taskSearch?.tasks || [],
        members: action.payload.members,
        teams: action.payload.teams,
        service_names: action.payload.service_names,
        label_groups: action.payload.label_groups,
        label_masters: action.payload.label_masters,
      }
      return state
    },
    addTaskSeparate: (state, action: PayloadAction<ResponsePostTaskSeparate>) => {
      state.isLoading = false
      if (!state.taskLabeling) return state
      state.taskLabeling.tasks = [...state.taskLabeling.tasks.map((task) => {
        if (task.task_id === action.payload.origin_task.task_id) {
          return {
            ...task,
            time: action.payload.origin_task.time,
            timeline: action.payload.origin_task.timeline,
          }
        }
        return task
      }), { ...action.payload.new_task }]
      return state
    },
    delTaskSeparate: (state, action: PayloadAction<{ data: ResponseDeleteTaskSeparate, delete_id: number }>) => {
      state.isLoading = false
      if (!state.taskLabeling) return state
      state.taskLabeling.tasks = state.taskLabeling.tasks.filter((task) => task.task_id !== action.payload.delete_id).map((task) => {
        if (task.task_id === action.payload.data.origin_task.task_id) {
          return {
            ...task,
            time: action.payload.data.origin_task.time,
            timeline: action.payload.data.origin_task.timeline,
          }
        }
        return task
      })
      return state
    },
    buildTaskThresholdSetting: (state, action: PayloadAction<ResponseGetTaskThresholdSetting>) => {
      state.isLoading = false
      state.taskThresholdSetting = action.payload
      return state
    },
    modTaskThresholdSetting: (state, action: PayloadAction<RequestPatchTaskThresholdSetting>) => {
      state.isLoading = false
      state.taskThresholdSetting = action.payload
      return state
    },
    buildTaskDisplayCreateManualTaskSetting: (state, action: PayloadAction<ResponseGetTaskDisplayCreateManualTaskSetting>) => {
      state.isLoading = false
      state.taskDisplayCreateManualTaskSetting = action.payload
      return state
    },
    modTaskDisplayCreateManualTaskSetting: (state, action: PayloadAction<RequestPatchTaskDisplayCreateManualTaskSetting>) => {
      state.isLoading = false
      state.taskDisplayCreateManualTaskSetting = action.payload
      return state
    },
    buildTaskOverwriteBreakTimeSetting: (state, action: PayloadAction<ResponseGetTaskOverwriteBreakTimeSetting>) => {
      state.isLoading = false
      state.taskOverwriteBreakTimeSetting = action.payload
      return state
    },
    modTaskOverwriteBreakTimeSetting: (state, action: PayloadAction<RequestPatchTaskOverwriteBreakTimeSetting>) => {
      state.isLoading = false
      state.taskOverwriteBreakTimeSetting = action.payload
      return state
    },
    buildTaskReportMember: (state, action: PayloadAction<ResponseGetTaskReportMember>) => {
      state.isLoading = false
      state.taskReportMember = action.payload
      return state
    },
    buildTaskReportTeam: (state, action: PayloadAction<ResponseGetTaskReportTeam>) => {
      state.isLoading = false
      state.taskReportTeam = action.payload
      return state
    },
    buildTaskProjectTemplateSetting: (state, action: PayloadAction<ResponseGetTaskProjectTemplateSetting>) => {
      state.isLoading = false
      state.taskProjectTemplateSetting = action.payload
      return state
    },
    buildTaskProjectTemplateSettingDetail: (state, action: PayloadAction<ResponseGetTaskProjectTemplateSettingDetail>) => {
      state.isLoading = false
      state.taskProjectTemplateSettingDetail = action.payload
      return state
    },
    buildTaskProjectTemplateSettingNewDetail: (state, action: PayloadAction<ResponseGetTaskProjectTemplateSettingNewDetail>) => {
      state.isLoading = false
      state.taskProjectTemplateSettingDetail = {
        label_group_template: undefined,
        target_services: action.payload.target_services,
        label_masters: action.payload.label_masters,
        teams: action.payload.teams,
        members: action.payload.members,
      }
      return state
    },
    modTaskProjectTemplateSetting: (state, action: PayloadAction<RequestPatchTaskProjectTemplateSetting>) => {
      state.isLoading = false
      if (!state.taskProjectTemplateSetting) return state
      state.taskProjectTemplateSetting.label_group_templates = state.taskProjectTemplateSetting.label_group_templates.map((label_group) => (
        label_group.id === Number(action.payload.id)
          ? {
            ...label_group,
            name: action.payload.name || label_group.name,
            description: action.payload.description || label_group.description,
            code: action.payload.code !== undefined ? action.payload.code : label_group.code,
            color: action.payload.color || label_group.color,
          }
          : label_group
      ))
      return state
    },
    delTaskProjectTemplateSetting: (state, action: PayloadAction<RequestDeleteTaskProjectTemplateSetting>) => {
      state.isLoading = false
      if (!state.taskProjectTemplateSetting) return state
      state.taskProjectTemplateSetting.label_group_templates = state.taskProjectTemplateSetting.label_group_templates.filter(
        (label_group) => label_group.id !== Number(action.payload.id),
      )
      return state
    },
    buildTaskApprovalGroup: (state, action: PayloadAction<ResponseGetTaskApprovalGroup>) => {
      state.isLoading = false
      state.taskApprovalGroup = action.payload
      return state
    },
    addTaskApprovalGroup: (state, action: PayloadAction<{result: ResponsePostTaskApprovalGroup, duplicationIds: number[]}>) => {
      state.isLoading = false
      if (!state.taskApprovalGroup) return state
      state.taskApprovalGroup.approval_groups = state.taskApprovalGroup.approval_groups.map((v) => {
        const tmpMemberIds = [...v.members.map((w) => w.member_id), ...action.payload.duplicationIds]
        const targetDuplicationIds = Array.from(new Set(tmpMemberIds.filter((w, _i, self) => (self.indexOf(w) !== self.lastIndexOf(w)))))
        if (targetDuplicationIds.length) {
          return {
            ...v,
            members: v.members.filter((w) => !targetDuplicationIds.includes(w.member_id)),
          }
        }
        return v
      })
      state.taskApprovalGroup?.approval_groups.push(action.payload.result)
      return state
    },
    modTaskApprovalGroup: (state, action: PayloadAction<{result: RequestPatchTaskApprovalGroup, duplicationIds: number[]}>) => {
      state.isLoading = false
      if (!state.taskApprovalGroup) return state
      const member = state.taskApprovalGroup.members
      const { approvers, member_ids } = action.payload.result
      state.taskApprovalGroup.approval_groups = state.taskApprovalGroup.approval_groups.map((v) => {
        if (v.approval_group_id === Number(action.payload.result.id)) {
          let tmpApprovals: {member_id: number, priority: number, name: string, kana: string | null, profile_image: string | null}[] = []
          let tmpMembers: {member_id: number, name: string, kana: string | null, profile_image: string | null}[] = []
          if (approvers) {
            tmpApprovals = member.filter((w) => approvers.map((x) => x.member_id).includes(w.member_id)).map((w) => (
              {
                ...w,
                priority: approvers.find((x) => x.member_id === w.member_id)?.priority || 0,
              }
            ))
          }
          if (member_ids) {
            tmpMembers = member.filter((w) => member_ids.includes(w.member_id))
          }
          return {
            ...v,
            name: action.payload.result.name || v.name,
            description: action.payload.result.description || v.description,
            approvers: tmpApprovals.length ? tmpApprovals : v.approvers,
            members: tmpMembers.length ? tmpMembers : v.members,
          }
        }
        const tmpMemberIds = [...v.members.map((w) => w.member_id), ...action.payload.duplicationIds]
        const targetDuplicationIds = Array.from(new Set(tmpMemberIds.filter((w, _i, self) => (self.indexOf(w) !== self.lastIndexOf(w)))))
        if (targetDuplicationIds.length) {
          return {
            ...v,
            members: v.members.filter((w) => !targetDuplicationIds.includes(w.member_id)),
          }
        }
        return v
      })
      return state
    },
    delTaskApprovalGroup: (state, action: PayloadAction<RequestDeleteTaskApprovalGroup>) => {
      state.isLoading = false
      if (!state.taskApprovalGroup) return state
      state.taskApprovalGroup.approval_groups = state.taskApprovalGroup.approval_groups.filter(
        (v) => v.approval_group_id !== Number(action.payload.id),
      )
      return state
    },
    buildTaskApprovalApplicationList: (state, action: PayloadAction<ResponseGetTaskApprovalApplicationList>) => {
      state.isLoading = false
      state.taskApprovalApplicationList = action.payload
      return state
    },
    buildTaskApprovalApplication: (state, action: PayloadAction<ResponseGetTaskApprovalApplication>) => {
      state.isLoading = false
      state.taskApprovalApplication = action.payload
      return state
    },
    addTaskApprovalApplication: (state, action: PayloadAction<{param: RequestPostTaskApprovalApplication, isComplete: boolean}>) => {
      state.isLoading = false
      const updateParams = action.payload.param.targets
      if (state.taskApprovalApplication) {
        state.taskApprovalApplication.members = state.taskApprovalApplication.members.map((member) => (
          {
            ...member,
            date_list: member.date_list.map((v) => {
              const target = updateParams.find((w) => (w.member_id === member.member_id) && (w.target_date === v.date))
              if (target) {
                return {
                  ...v,
                  approval_status: action.payload.isComplete ? "completed" : action.payload.param.status,
                }
              }
              return v
            }),
          }
        ))
      }
      if (state.taskApprovalApplicationList) {
        state.taskApprovalApplicationList.members = state.taskApprovalApplicationList.members.map((member) => (
          {
            ...member,
            date_list: member.date_list.map((v) => {
              const target = updateParams.find((w) => (w.member_id === member.member_id) && (w.target_date === v.date))
              if (target) {
                return {
                  ...v,
                  approval_status: action.payload.isComplete ? "completed" : action.payload.param.status,
                }
              }
              return v
            }),
          }
        ))
      }
      return state
    },
    buildTaskApprovalApplicationDetail: (state, action: PayloadAction<ResponseGetTaskApprovalApplicationDetail>) => {
      state.isLoadingForModal = false
      state.taskApprovalApplicationDetail = action.payload
      return state
    },
    buildTaskExcludeGenerateMemberSetting: (state, action: PayloadAction<ResponseGetTaskExcludeGenerateMemberSetting>) => {
      state.isLoading = false
      state.taskExcludeGenerateMemberSetting = action.payload
      return state
    },
    addTaskExcludeGenerateMemberSetting: (state, action: PayloadAction<RequestPostTaskExcludeGenerateMemberSetting>) => {
      state.isLoading = false
      if (!state.taskExcludeGenerateMemberSetting) return state
      const addMembers = state.taskExcludeGenerateMemberSetting?.full_members
        .filter((v) => action.payload.member_ids.includes(v.member_id))
        .map((v) => ({ ...v, created_at: nowDate("") })) || []
      state.taskExcludeGenerateMemberSetting = {
        exclude_members: [...state.taskExcludeGenerateMemberSetting?.exclude_members, ...addMembers],
        full_members: state.taskExcludeGenerateMemberSetting?.full_members || [],
      }
      return state
    },
    delTaskExcludeGenerateMemberSetting: (state, action: PayloadAction<RequestDeleteTaskExcludeGenerateMemberSetting>) => {
      state.isLoading = false
      if (!state.taskExcludeGenerateMemberSetting) return state
      state.taskExcludeGenerateMemberSetting = {
        exclude_members: state.taskExcludeGenerateMemberSetting?.exclude_members.filter((v) => v.member_id !== Number(action.payload.id)) || [],
        full_members: state.taskExcludeGenerateMemberSetting?.full_members || [],
      }
      return state
    },
    buildTaskLabelGroupCategory: (state, action: PayloadAction<ResponseGetTaskLabelGroupCategory>) => {
      state.isLoading = false
      state.taskLabelGroupCategory = action.payload
      return state
    },
    addTaskLabelGroupCategory: (state, action: PayloadAction<ResponsePostTaskLabelGroupCategory>) => {
      state.isLoading = false
      if (!state.taskLabelGroupCategory) return state
      state.taskLabelGroupCategory?.label_group_categories.push(action.payload)
      return state
    },
    modTaskLabelGroupCategory: (state, action: PayloadAction<RequestPatchTaskLabelGroupCategory>) => {
      state.isLoading = false
      if (!state.taskLabelGroupCategory) return state
      const param = action.payload
      const member = state.taskLabelGroupCategory.members
      const labelGroup = state.taskLabelGroupCategory.label_groups
      state.taskLabelGroupCategory.label_group_categories = state.taskLabelGroupCategory.label_group_categories.map((v) => {
        if (v.id === Number(param.id)) {
          let tmpMembers: {member_id: number, name: string, kana: string | null, profile_image: string | null}[] = []
          if (param.member_ids) {
            tmpMembers = member.filter((w) => param.member_ids?.includes(w.member_id))
          }
          let tmpLabelGroups: {id: number, name: string, code: string | null, color: string}[] = []
          if (param.label_groups?.removed_ids) {
            tmpLabelGroups = v.label_groups.filter((w) => !param.label_groups?.removed_ids?.includes(w.id))
          }
          if (param.label_groups?.added_ids) {
            tmpLabelGroups = [...tmpLabelGroups, ...labelGroup.filter((w) => param.label_groups?.added_ids?.includes(w.id))]
          }
          return {
            ...v,
            category_name: param.category_name || v.category_name,
            color: param.color || v.color,
            parent_id: param.parent_id || null,
            members: tmpMembers.length ? tmpMembers : [],
            label_groups: tmpLabelGroups.length ? tmpLabelGroups : [],
            label_group_count: v.label_group_count + (param.label_groups?.added_ids?.length || 0) - (param.label_groups?.removed_ids?.length || 0),
          }
        }
        return v
      })
      return state
    },
    delTaskLabelGroupCategory: (state, action: PayloadAction<RequestDeleteTaskLabelGroupCategory>) => {
      state.isLoading = false
      if (!state.taskLabelGroupCategory) return state
      state.taskLabelGroupCategory.label_group_categories = state.taskLabelGroupCategory.label_group_categories.filter(
        (v) => v.id !== Number(action.payload.id),
      )
      return state
    },
    buildTaskReportLabelGroupCategory: (state, action: PayloadAction<ResponseGetTaskReportLabelGroupCategory>) => {
      state.isLoading = false
      state.taskReportLabelGroupCategory = action.payload
      return state
    },
    buildTaskReportLabelGroupCategoryDetail: (state, action: PayloadAction<ResponseGetTaskReportLabelGroupCategoryDetail>) => {
      state.isLoading = false
      state.taskReportLabelGroupCategoryDetail = action.payload
      return state
    },
    buildTaskReportLabelGroupCategoryDetailMax: (state, action: PayloadAction<ResponseGetTaskReportLabelGroupCategoryDetailMax>) => {
      state.isLoading = false
      state.taskReportLabelGroupCategoryDetailMax = action.payload
      return state
    },
    buildTaskReportLabelGroupCategoryDetailSummary: (state, action: PayloadAction<ResponseGetTaskReportLabelGroupCategoryDetailSummary>) => {
      state.isLoading = false
      if (state.taskReportLabelGroupCategoryDetailSummary) {
        state.taskReportLabelGroupCategoryDetailSummary.months = [
          ...state.taskReportLabelGroupCategoryDetailSummary.months,
          ...action.payload.months,
        ].sort((a, b) => Number(format(a.date, "YYYYMM")) - Number(format(b.date, "YYYYMM")))
      } else {
        state.taskReportLabelGroupCategoryDetailSummary = action.payload
      }
      return state
    },
    initTaskReportLabelGroupCategoryDetailSummary: (state) => {
      state.isLoading = false
      if (state.taskReportLabelGroupCategoryDetailSummary) {
        state.taskReportLabelGroupCategoryDetailSummary.months = []
      }
      return state
    },
    addTaskLabelGroupImport: (state, action: PayloadAction<ResponsePostTaskLabelGroupImport>) => {
      state.isLoadingForModal = false
      state.taskLabelGroupImport = action.payload
      return state
    },
    buildTaskCustomSearch: (state, action: PayloadAction<ResponseGetTaskCustomSearch>) => {
      state.isLoading = false
      state.taskCustomSearch = {
        tasks: action.payload.tasks || [],
        members: state.taskCustomSearch?.members || [],
        target_services: state.taskCustomSearch?.target_services || [],
        label_groups: action.payload.label_groups || [],
        all_label_groups: state.taskCustomSearch?.all_label_groups || [],
        params: action.payload.params || null,
      }
      return state
    },
    buildTaskCustomSearchNew: (state, action: PayloadAction<ResponseGetTaskCustomSearchNew>) => {
      state.isLoading = false
      state.taskCustomSearch = {
        tasks: state.taskCustomSearch?.tasks || [],
        members: action.payload.members,
        target_services: action.payload.target_services,
        label_groups: state.taskCustomSearch?.label_groups || [],
        all_label_groups: action.payload.label_groups,
        params: state.taskCustomSearch?.params || null,
      }
      return state
    },
    buildTaskGanttChartList: (state, action: PayloadAction<ResponseGetTaskGanttChartList>) => {
      state.isLoading = false
      state.taskGanttChartList = action.payload
      return state
    },
    buildTaskGanttChart: (state, action: PayloadAction<ResponseGetTaskGanttChart>) => {
      if (!state.taskGanttCharts) {
        state.taskGanttCharts = [action.payload]
        return state
      }
      if (state.taskGanttCharts?.filter((v) => v.id === action.payload.id && v.block_type === action.payload.block_type).length) {
        const tmpData = state.taskGanttCharts?.map((v) => (
          v.id === action.payload.id && v.block_type === action.payload.block_type ? action.payload : v
        ))
        state.taskGanttCharts = tmpData
        return state
      }
      state.taskGanttCharts.push(action.payload)
      return state
    },
    buildTaskGanttChartDetail: (state, action: PayloadAction<ResponseGetTaskGanttChartDetail>) => {
      state.isLoading = false
      state.taskGanttChartDetail = action.payload
      return state
    },
    addTaskExcludeAutoLabelingTask: (state, action: PayloadAction<ResponsePostTaskExcludeAutoLabelingTask>) => {
      state.isLoading = false
      if (!state.taskLabeling) return state
      state.taskLabeling.tasks = state.taskLabeling.tasks.map((v) => (
        v.task_id === action.payload.task_id
          ? { ...v, exclusion_id: action.payload.exclusion_id }
          : v
      ))
      return state
    },
    delTaskExcludeAutoLabelingTask: (state, action: PayloadAction<RequestDeleteTaskExcludeAutoLabelingTask>) => {
      state.isLoading = false
      if (!state.taskLabeling) return state
      state.taskLabeling.tasks = state.taskLabeling.tasks.map((v) => (
        v.exclusion_id === action.payload.id
          ? { ...v, exclusion_id: null }
          : v
      ))
      return state
    },
    addTaskLabelMasterImport: (state, action: PayloadAction<ResponsePostTaskLabelMasterImport>) => {
      state.isLoadingForModal = false
      state.taskLabelMasterImport = action.payload
      return state
    },
    buildTaskLearningScopeSetting: (state, action: PayloadAction<ResponseGetTaskLearningScopeSetting>) => {
      state.isLoading = false
      state.taskLearningScopeSetting = action.payload
    },
    modTaskLearningScopeSetting: (state, action: PayloadAction<RequestPatchTaskLearningScopeSetting>) => {
      state.isLoading = false
      state.taskLearningScopeSetting = action.payload
    },
    buildTaskLabelingTargetModeSetting: (state, action: PayloadAction<ResponseGetTaskLabelingTargetModeSetting>) => {
      state.isLoading = false
      state.taskLabelingTargetModeSetting = action.payload
    },
    modTaskLabelingTargetModeSetting: (state, action: PayloadAction<RequestPatchTaskLabelingTargetModeSetting>) => {
      state.isLoading = false
      state.taskLabelingTargetModeSetting = action.payload
    },
    buildTaskCompanyServiceName: (state, action: PayloadAction<ResponseGetTaskCompanyServiceName>) => {
      state.isLoading = false
      state.taskCompanyServiceName = action.payload
    },
    buildTaskBulkLabeling: (state, action: PayloadAction<ResponseGetTaskBulkLabeling>) => {
      state.isLoading = false
      state.taskBulkLabeling = {
        label_groups: state.taskBulkLabeling?.label_groups || [],
        grouped_tasks: action.payload.grouped_tasks.map((v, i) => ({ ...v, gt_id: i + 1 })) || [],
        service_names: action.payload.service_names || [],
        labels: action.payload.labels || [],
      }
      return state
    },
    buildTaskBulkLabelingNew: (state, action: PayloadAction<ResponseGetTaskBulkLabelingNew>) => {
      state.isLoading = false
      state.taskBulkLabeling = {
        label_groups: action.payload.label_groups || [],
        grouped_tasks: state.taskBulkLabeling?.grouped_tasks.map((v, i) => ({ ...v, gt_id: i + 1 })) || [],
        service_names: state.taskBulkLabeling?.service_names || [],
        labels: state.taskBulkLabeling?.labels || [],
      }
      return state
    },
    buildTaskLabelGroupOrder: (state, action: PayloadAction<ResponseGetTaskLabelGroupOrder>) => {
      state.isLoading = false
      state.taskLabelGroupOrder = action.payload
    },
    modTaskLabelGroupOrder: (state, action: PayloadAction<RequestPatchTaskLabelGroupOrder>) => {
      state.isLoading = false
      if (!state.taskLabelGroupOrder) return
      const groups = state.taskLabelGroupOrder.label_groups
      if (!groups || groups.length === 0) return
      const { label_group_ids, to_order_index } = action.payload

      const block = sortBy(groups.filter((g) => label_group_ids.includes(g.id)), ['order_index', 'id'])
      if (block.length === 0) return
      const start = block[0].order_index
      const finish = block[block.length - 1].order_index
      const m = block.length
      const moveUp = to_order_index <= start

      const [affectedOrder, unaffectedOrder] = partition(groups, (g) => {
        if (label_group_ids.includes(g.id)) return true
        if (moveUp) {
          return g.order_index >= to_order_index && g.order_index <= start - 1
        }
        return g.order_index >= finish + 1 && g.order_index <= to_order_index
      })

      const updatedShift = affectedOrder.filter((g) => !label_group_ids.includes(g.id)).map((g) => ({
        ...g,
        order_index: g.order_index + (moveUp ? m : -m),
      }))

      const newStart = moveUp ? to_order_index : to_order_index - m + 1
      const diff = newStart - start
      const updatedBlock = block.map((b) => ({
        ...b,
        order_index: b.order_index + diff,
      }))

      state.taskLabelGroupOrder.label_groups = sortBy(
        [...unaffectedOrder, ...updatedShift, ...updatedBlock],
        ['order_index', 'id'],
      )
    },
    buildTaskNotWorkingRanges: (state, action: PayloadAction<ResponseGetTaskNotWorkingRange>) => {
      state.isLoading = false
      state.taskNotWorkingRange = action.payload
    },
    modTaskNotWorkingRanges: (state, action: PayloadAction<RequestPatchTaskNotWorkingRange>) => {
      state.isLoading = false
      if (!state.taskNotWorkingRange) return
      state.taskNotWorkingRange.not_working_ranges = action.payload.not_working_ranges
    },
    buildTaskSearchLabelGroup: (state, action: PayloadAction<ResponseGetTaskSearchLabelGroup>) => {
      state.isLoading = false
      state.taskSearchLabelGroup = action.payload
    },
    buildTaskRecentlyUsedLabelGroup: (state, action: PayloadAction<ResponseGetTaskRecentlyUsedLabelGroup>) => {
      state.isLoading = false
      state.taskRecentlyUsedLabelGroup = action.payload
    },
    resetState: (state) => {
      // eslint-disable-next-line no-param-reassign
      state = initialState
      return state
    },
  },
})

export const {
  requestStart,
  requestStartForModal,
  buildTaskLabeling,
  changeTaskLabelingStart,
  changeTaskLabelingStatus,
  addTaskLabeling,
  modTaskLabeling,
  delTaskLabeling,
  addTaskManual,
  delTaskManual,
  buildTaskTargetServiceSetting,
  addTaskTargetServiceSetting,
  delTaskTargetServiceSetting,
  buildTaskLabelMasterSetting,
  addTaskLabelMasterSetting,
  modTaskLabelMasterSetting,
  delTaskLabelMasterSetting,
  buildTaskLabelSetting,
  buildTaskLabelSettingDetail,
  buildTaskLabelSettingNewDetail,
  modTaskLabelSettingLabelGroup,
  delTaskLabelSettingLabelGroup,
  modTaskLabelSettingTeamLabelRelation,
  buildTaskLabelingStatus,
  buildTaskReportLabelGroup,
  buildTaskReportLabelGroupDetail,
  buildTaskReportLabelGroupDetailMax,
  buildTaskReportLabelGroupDetailSummary,
  modTaskReportLabelGroupDetailSummary,
  initTaskReportLabelGroupDetailSummary,
  buildTaskExportList,
  buildTaskPermission,
  addTaskPermission,
  modTaskPermission,
  delTaskPermission,
  buildTaskCostSetting,
  modTaskCostSetting,
  buildTaskSearch,
  buildTaskSearchNew,
  addTaskSeparate,
  delTaskSeparate,
  buildTaskThresholdSetting,
  modTaskThresholdSetting,
  buildTaskDisplayCreateManualTaskSetting,
  modTaskDisplayCreateManualTaskSetting,
  buildTaskOverwriteBreakTimeSetting,
  modTaskOverwriteBreakTimeSetting,
  buildTaskReportMember,
  buildTaskReportTeam,
  buildTaskProjectTemplateSetting,
  buildTaskProjectTemplateSettingDetail,
  buildTaskProjectTemplateSettingNewDetail,
  modTaskProjectTemplateSetting,
  delTaskProjectTemplateSetting,
  buildTaskApprovalGroup,
  addTaskApprovalGroup,
  modTaskApprovalGroup,
  delTaskApprovalGroup,
  buildTaskApprovalApplicationList,
  buildTaskApprovalApplication,
  addTaskApprovalApplication,
  buildTaskApprovalApplicationDetail,
  buildTaskExcludeGenerateMemberSetting,
  addTaskExcludeGenerateMemberSetting,
  delTaskExcludeGenerateMemberSetting,
  buildTaskLabelGroupCategory,
  addTaskLabelGroupCategory,
  modTaskLabelGroupCategory,
  delTaskLabelGroupCategory,
  buildTaskReportLabelGroupCategory,
  buildTaskReportLabelGroupCategoryDetail,
  buildTaskReportLabelGroupCategoryDetailMax,
  buildTaskReportLabelGroupCategoryDetailSummary,
  initTaskReportLabelGroupCategoryDetailSummary,
  addTaskLabelGroupImport,
  buildTaskCustomSearch,
  buildTaskCustomSearchNew,
  buildTaskGanttChartList,
  buildTaskGanttChart,
  buildTaskGanttChartDetail,
  addTaskExcludeAutoLabelingTask,
  delTaskExcludeAutoLabelingTask,
  addTaskLabelMasterImport,
  buildTaskLearningScopeSetting,
  modTaskLearningScopeSetting,
  buildTaskLabelingTargetModeSetting,
  modTaskLabelingTargetModeSetting,
  buildTaskCompanyServiceName,
  buildTaskBulkLabeling,
  buildTaskBulkLabelingNew,
  buildTaskLabelGroupOrder,
  modTaskLabelGroupOrder,
  buildTaskNotWorkingRanges,
  modTaskNotWorkingRanges,
  buildTaskSearchLabelGroup,
  buildTaskRecentlyUsedLabelGroup,
  resetState,
} = taskSlice.actions

export const taskReducer = taskSlice.reducer
// eslint-disable-next-line @typescript-eslint/no-var-requires
const FileDownload = require('js-file-download')

export const fetchTaskLabeling = (
  param: RequestGetTaskLabeling,
  displayLoad = true,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  if (displayLoad) dispatch(requestStart())
  getTaskLabeling(param)
    .then((result: ResponseGetTaskLabeling) => {
      dispatch(buildTaskLabeling(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskLabeling = (
  param: RequestPostTaskLabelingPre,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  const formatParam: RequestPostTaskLabeling = {
    task_ids: param.task_ids,
    label_group_id: param.label_group.id,
    label_id: param.label.id,
  }
  if (param.option) formatParam.option = param.option
  postTaskLabeling(formatParam)
    .then(() => {
      dispatch(addTaskLabeling(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskLabeling = (
  param: RequestPatchTaskLabeling,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskLabeling(param)
    .then(() => {
      dispatch(modTaskLabeling(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskLabeling = (
  param: RequestDeleteTaskLabeling,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskLabeling(param)
    .then(() => {
      dispatch(delTaskLabeling(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskManual = (
  param: RequestPostTaskManual,
  callback?: (id: number) => void,
): AppThunk => async (dispatch) => {
  postTaskManual(param)
    .then((result: ResponsePostTaskManual) => {
      dispatch(addTaskManual(result))
      if (callback) {
        callback(result.task_id)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskManual = (
  param: RequestDeleteTaskManual,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskManual(param)
    .then((result: ResponseDeleteTaskManual) => {
      dispatch(delTaskManual({ param: param, result: result }))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskTargetServiceSetting = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskTargetServiceSetting()
    .then((result: ResponseGetTaskTargetServiceSetting) => {
      dispatch(buildTaskTargetServiceSetting(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskTargetServiceSetting = (
  param: RequestPostTaskTargetServiceSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  postTaskTargetServiceSetting(param)
    .then((result: ResponsePostTaskTargetServiceSetting[]) => {
      dispatch(addTaskTargetServiceSetting(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskTargetServiceSetting = (
  param: RequestDeleteTaskTargetServiceSetting,
): AppThunk => async (dispatch) => {
  deleteTaskTargetServiceSetting(param)
    .then(() => {
      dispatch(delTaskTargetServiceSetting(param))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskLabelMasterSetting = (
  param: RequestGetTaskLabelMasterSetting,
  callback?: (result: ResponseGetTaskLabelMasterSetting) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskLabelMasterSetting(param)
    .then((result: ResponseGetTaskLabelMasterSetting) => {
      dispatch(buildTaskLabelMasterSetting(result))
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskLabelMasterSetting = (
  param: RequestPostTaskLabelMasterSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  postTaskLabelMasterSetting(param)
    .then((result: ResponsePostTaskLabelMasterSetting) => {
      dispatch(addTaskLabelMasterSetting(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskLabelMasterSetting = (
  param: RequestPatchTaskLabelMasterSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskLabelMasterSetting(param)
    .then(() => {
      dispatch(modTaskLabelMasterSetting(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskLabelMasterSetting = (
  param: RequestDeleteTaskLabelMasterSetting,
): AppThunk => async (dispatch) => {
  deleteTaskLabelMasterSetting(param)
    .then(() => {
      dispatch(delTaskLabelMasterSetting(param))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskLabelSetting = (
  params: RequestGetTaskLabelSetting,
  callback?: (result: ResponseGetTaskLabelSetting) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskLabelSetting(params)
    .then((result: ResponseGetTaskLabelSetting) => {
      dispatch(buildTaskLabelSetting(result))
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskLabelSettingDetail = (
  params: RequestGetTaskLabelSettingDetail,
  callback?: (result: ResponseGetTaskLabelSettingDetail) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskLabelSettingDetail(params)
    .then((result: ResponseGetTaskLabelSettingDetail) => {
      dispatch(buildTaskLabelSettingDetail(result))
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskLabelSettingNewDetail = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskLabelSettingNewDetail()
    .then((result: ResponseGetTaskLabelSettingNewDetail) => {
      dispatch(buildTaskLabelSettingNewDetail(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskLabelSettingLabelGroup = (
  param: RequestPostTaskLabelSettingLabelGroup,
  callback?: (id: number) => void,
): AppThunk => async (dispatch) => {
  postTaskLabelSettingLabelGroup(param)
    .then((result: ResponsePostTaskLabelSettingLabelGroup) => {
      if (callback) {
        callback(result.id)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskLabelSettingLabelGroup = (
  param: RequestPatchTaskLabelSettingLabelGroup,
  callback?: (id: number) => void,
): AppThunk => async (dispatch) => {
  patchTaskLabelSettingLabelGroup(param)
    .then(() => {
      if (callback) {
        callback(Number(param.id))
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskLabelSettingLabelGroup = (
  param: RequestDeleteTaskLabelSettingLabelGroup,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskLabelSettingLabelGroup(param)
    .then(() => {
      dispatch(delTaskLabelSettingLabelGroup(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskLabelSettingTeamLabelRelation = (
  param: RequestPatchTaskLabelSettingTeamLabelRelationTmp,
): AppThunk => async (dispatch) => {
  const newParams = { label_group_id: param.label_group_id, team_ids: param.teams.map((v) => v.id) }
  patchTaskLabelSettingTeamLabelRelation(newParams)
    .then(() => {
      dispatch(modTaskLabelSettingTeamLabelRelation(param))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskLabelingStatus = (
  param: RequestGetTaskLabelingStatus,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskLabelingStatus(param)
    .then((result: ResponseGetTaskLabelingStatus) => {
      dispatch(buildTaskLabelingStatus(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskReportLabelGroup = (
  param: RequestGetTaskReportLabelGroup,
  callback?: (result: ResponseGetTaskReportLabelGroup) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskReportLabelGroup(param)
    .then((result: ResponseGetTaskReportLabelGroup) => {
      dispatch(buildTaskReportLabelGroup(result))
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskReportLabelGroupDetail = (
  param: RequestGetTaskReportLabelGroupDetail,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskReportLabelGroupDetail(param)
    .then((result: ResponseGetTaskReportLabelGroupDetail) => {
      dispatch(buildTaskReportLabelGroupDetail(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskReportLabelGroupDetailMax = (
  param: RequestGetTaskReportLabelGroupDetailMax,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskReportLabelGroupDetailMax(param)
    .then((result: ResponseGetTaskReportLabelGroupDetailMax) => {
      dispatch(buildTaskReportLabelGroupDetailMax(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskReportLabelGroupDetailSummary = (
  param: RequestGetTaskReportLabelGroupDetailSummary,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  getTaskReportLabelGroupDetailSummary(param)
    .then((result: ResponseGetTaskReportLabelGroupDetailSummary) => {
      dispatch(buildTaskReportLabelGroupDetailSummary(result))
      if (callback) callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskReportLabelGroupDetailSummary = (
  param: RequestPatchTaskReportLabelGroupDetailSummary,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskReportLabelGroupDetailSummary(param)
    .then(() => {
      dispatch(modTaskReportLabelGroupDetailSummary(param))
      if (callback) callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const resetTaskReportLabelGroupDetailSummary = (
): AppThunk => async (dispatch) => {
  dispatch(initTaskReportLabelGroupDetailSummary())
}

export const fetchTaskExportList = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskExportList()
    .then((result: ResponseGetTaskExportList) => {
      dispatch(buildTaskExportList(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskExportDetail = (
  param: RequestGetTaskExportDetail,
  callback: (url: string) => void,
): AppThunk => async (dispatch) => {
  getTaskExportDetail(param)
    .then((response) => {
      callback(response.url)
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskExportDetail = (
  params: RequestPostTaskExportDetail,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postTaskExportDetail(params)
    .then(() => {
      callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskPermission = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskPermission()
    .then((result: ResponseGetTaskPermission) => {
      dispatch(buildTaskPermission(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskPermission = (
  param: RequestPostTaskPermission,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  postTaskPermission(param)
    .then((result: ResponsePostTaskPermission) => {
      dispatch(addTaskPermission(result))
      dispatch(
        fetchAccessToken(
          () => { /* */ },
          () => { /* */ },
        ),
      )
      if (callback) callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskPermission = (
  param: RequestPatchTaskPermission,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskPermission(param)
    .then(() => {
      dispatch(
        fetchAccessToken(
          () => { /* */ },
          () => { /* */ },
        ),
      )
      if (callback) callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskPermission = (
  param: RequestDeleteTaskPermission,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskPermission(param)
    .then(() => {
      dispatch(delTaskPermission(param))
      dispatch(
        fetchAccessToken(
          () => { /* */ },
          () => { /* */ },
        ),
      )
      if (callback) callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskCostSetting = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskCostSetting()
    .then((result: ResponseGetTaskCostSetting) => {
      dispatch(buildTaskCostSetting(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskCostSetting = (
  param: RequestPostTaskCostSetting,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postTaskCostSetting(param)
    .then((result: ResponsePostTaskCostSetting) => {
      dispatch(buildTaskCostSetting(result))
      callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskCostSetting = (
  param: RequestPatchTaskCostSetting,
  callback: () => void,
): AppThunk => async (dispatch) => {
  patchTaskCostSetting(param)
    .then(() => {
      dispatch(modTaskCostSetting(param))
      callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskSearch = (
  param: RequestGetTaskSearch,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  getTaskSearch(param)
    .then((result: ResponseGetTaskSearch) => {
      dispatch(buildTaskSearch(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskSearchNew = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskSearchNew()
    .then((result: ResponseGetTaskSearchNew) => {
      dispatch(buildTaskSearchNew(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskSeparate = (
  param: RequestPostTaskSeparate,
  callback?: (id: number) => void,
): AppThunk => async (dispatch) => {
  postTaskSeparate(param)
    .then((result: ResponsePostTaskSeparate) => {
      dispatch(addTaskSeparate(result))
      if (callback) {
        callback(result.new_task.task_id)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskSeparate = (
  param: RequestDeleteTaskSeparate,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskSeparate(param)
    .then((result: ResponseDeleteTaskSeparate) => {
      dispatch(delTaskSeparate({ data: result, delete_id: Number(param.id) }))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskThresholdSetting = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskThresholdSetting()
    .then((result: ResponseGetTaskThresholdSetting) => {
      dispatch(buildTaskThresholdSetting(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskThresholdSetting = (
  param: RequestPatchTaskThresholdSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskThresholdSetting(param)
    .then(() => {
      dispatch(modTaskThresholdSetting(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskDisplayCreateManualTaskSetting = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskDisplayCreateManualTaskSetting()
    .then((result: ResponseGetTaskDisplayCreateManualTaskSetting) => {
      dispatch(buildTaskDisplayCreateManualTaskSetting(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskDisplayCreateManualTaskSetting = (
  param: RequestPatchTaskDisplayCreateManualTaskSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskDisplayCreateManualTaskSetting(param)
    .then(() => {
      dispatch(modTaskDisplayCreateManualTaskSetting(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskOverwriteBreakTimeSetting = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskOverwriteBreakTimeSetting()
    .then((result: ResponseGetTaskOverwriteBreakTimeSetting) => {
      dispatch(buildTaskOverwriteBreakTimeSetting(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskOverwriteBreakTimeSetting = (
  param: RequestPatchTaskOverwriteBreakTimeSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskOverwriteBreakTimeSetting(param)
    .then(() => {
      dispatch(modTaskOverwriteBreakTimeSetting(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskReportMember = (
  param: RequestGetTaskReportMember,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskReportMember(param)
    .then((result: ResponseGetTaskReportMember) => {
      dispatch(buildTaskReportMember(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskReportTeam = (
  param: RequestGetTaskReportTeam,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskReportTeam(param)
    .then((result: ResponseGetTaskReportTeam) => {
      dispatch(buildTaskReportTeam(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskProjectTemplateSetting = (
  params: RequestGetTaskProjectTemplateSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  getTaskProjectTemplateSetting(params)
    .then((result: ResponseGetTaskProjectTemplateSetting) => {
      dispatch(buildTaskProjectTemplateSetting(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskProjectTemplateSettingDetail = (
  params: RequestGetTaskProjectTemplateSettingDetail,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskProjectTemplateSettingDetail(params)
    .then((result: ResponseGetTaskProjectTemplateSettingDetail) => {
      dispatch(buildTaskProjectTemplateSettingDetail(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskProjectTemplateSettingNewDetail = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskProjectTemplateSettingNewDetail()
    .then((result: ResponseGetTaskProjectTemplateSettingNewDetail) => {
      dispatch(buildTaskProjectTemplateSettingNewDetail(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskProjectTemplateSetting = (
  param: RequestPostTaskProjectTemplateSetting,
  callback?: (id: number) => void,
): AppThunk => async (dispatch) => {
  postTaskProjectTemplateSetting(param)
    .then((result: ResponsePostTaskProjectTemplateSetting) => {
      if (callback) {
        callback(result.id)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskProjectTemplateSetting = (
  param: RequestPatchTaskProjectTemplateSetting,
  callback?: (id: number) => void,
): AppThunk => async (dispatch) => {
  patchTaskProjectTemplateSetting(param)
    .then(() => {
      dispatch(modTaskProjectTemplateSetting(param))
      if (callback) {
        callback(Number(param.id))
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskProjectTemplateSetting = (
  param: RequestDeleteTaskProjectTemplateSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskProjectTemplateSetting(param)
    .then(() => {
      dispatch(delTaskProjectTemplateSetting(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskApprovalGroup = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskApprovalGroup()
    .then((result: ResponseGetTaskApprovalGroup) => {
      dispatch(buildTaskApprovalGroup(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskApprovalGroup = (
  param: RequestPostTaskApprovalGroup,
  duplicationIds: number[],
  callback?: () => void,
): AppThunk => async (dispatch) => {
  postTaskApprovalGroup(param)
    .then((result: ResponsePostTaskApprovalGroup) => {
      dispatch(addTaskApprovalGroup({ result: result, duplicationIds: duplicationIds }))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskApprovalGroup = (
  param: RequestPatchTaskApprovalGroup,
  duplicationIds: number[],
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskApprovalGroup(param)
    .then(() => {
      dispatch(modTaskApprovalGroup({ result: param, duplicationIds: duplicationIds }))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskApprovalGroup = (
  param: RequestDeleteTaskApprovalGroup,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskApprovalGroup(param)
    .then(() => {
      dispatch(delTaskApprovalGroup(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskApprovalApplicationList = (
  param: RequestGetTaskApprovalApplicationList,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskApprovalApplicationList(param)
    .then((result: ResponseGetTaskApprovalApplicationList) => {
      dispatch(buildTaskApprovalApplicationList(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskApprovalApplication = (
  param: RequestGetTaskApprovalApplication,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskApprovalApplication(param)
    .then((result: ResponseGetTaskApprovalApplication) => {
      dispatch(buildTaskApprovalApplication(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskApprovalApplication = (
  param: RequestPostTaskApprovalApplication,
  isComplete: boolean,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  postTaskApprovalApplication(param)
    .then(() => {
      dispatch(addTaskApprovalApplication({ param: param, isComplete: isComplete }))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskApprovalApplicationDetail = (
  param: RequestGetTaskApprovalApplicationDetail,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStartForModal())
  getTaskApprovalApplicationDetail(param)
    .then((result: ResponseGetTaskApprovalApplicationDetail) => {
      dispatch(buildTaskApprovalApplicationDetail(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskExcludeGenerateMemberSetting = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskExcludeGenerateMemberSetting()
    .then((result: ResponseGetTaskExcludeGenerateMemberSetting) => {
      dispatch(buildTaskExcludeGenerateMemberSetting(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskExcludeGenerateMemberSetting = (
  param: RequestPostTaskExcludeGenerateMemberSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  postTaskExcludeGenerateMemberSetting(param)
    .then(() => {
      dispatch(addTaskExcludeGenerateMemberSetting(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskExcludeGenerateMemberSetting = (
  param: RequestDeleteTaskExcludeGenerateMemberSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskExcludeGenerateMemberSetting(param)
    .then(() => {
      dispatch(delTaskExcludeGenerateMemberSetting(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskLabelGroupCategory = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskLabelGroupCategory()
    .then((result: ResponseGetTaskLabelGroupCategory) => {
      dispatch(buildTaskLabelGroupCategory(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskLabelGroupCategoryLabelGroup = (
  param: RequestGetTaskLabelGroupCategoryLabelGroup,
  callback?: (result: ResponseGetTaskLabelGroupCategoryLabelGroup) => void,
): AppThunk => async (dispatch) => {
  getTaskLabelGroupCategoryLabelGroup(param)
    .then((result: ResponseGetTaskLabelGroupCategoryLabelGroup) => {
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskLabelGroupCategory = (
  param: RequestPostTaskLabelGroupCategory,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  postTaskLabelGroupCategory(param)
    .then((result: ResponsePostTaskLabelGroupCategory) => {
      dispatch(addTaskLabelGroupCategory(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskLabelGroupImport = (
  param: FormData,
  callback?: (result: ResponsePostTaskLabelGroupImport) => void,
  errorCallback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStartForModal())
  postTaskLabelGroupImport(param)
    .then((result: ResponsePostTaskLabelGroupImport) => {
      dispatch(addTaskLabelGroupImport(result))
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
      if (errorCallback) {
        errorCallback()
      }
    })
}

export const updateTaskLabelGroupCategory = (
  param: RequestPatchTaskLabelGroupCategory,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskLabelGroupCategory(param)
    .then(() => {
      dispatch(modTaskLabelGroupCategory(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskLabelGroupCategory = (
  param: RequestDeleteTaskLabelGroupCategory,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskLabelGroupCategory(param)
    .then(() => {
      dispatch(delTaskLabelGroupCategory(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskReportLabelGroupCategory = (
  param: RequestGetTaskReportLabelGroupCategory,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskReportLabelGroupCategory(param)
    .then((result: ResponseGetTaskReportLabelGroupCategory) => {
      dispatch(buildTaskReportLabelGroupCategory(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskReportLabelGroupCategoryDetail = (
  param: RequestGetTaskReportLabelGroupCategoryDetail,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskReportLabelGroupCategoryDetail(param)
    .then((result: ResponseGetTaskReportLabelGroupCategoryDetail) => {
      dispatch(buildTaskReportLabelGroupCategoryDetail(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskReportLabelGroupCategoryDetailMax = (
  param: RequestGetTaskReportLabelGroupCategoryDetailMax,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskReportLabelGroupCategoryDetailMax(param)
    .then((result: ResponseGetTaskReportLabelGroupCategoryDetailMax) => {
      dispatch(buildTaskReportLabelGroupCategoryDetailMax(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskReportLabelGroupCategoryDetailSummary = (
  param: RequestGetTaskReportLabelGroupCategoryDetailSummary,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  getTaskReportLabelGroupCategoryDetailSummary(param)
    .then((result: ResponseGetTaskReportLabelGroupCategoryDetailSummary) => {
      dispatch(buildTaskReportLabelGroupCategoryDetailSummary(result))
      if (callback) callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const resetTaskReportLabelGroupCategoryDetailSummary = (
): AppThunk => async (dispatch) => {
  dispatch(initTaskReportLabelGroupCategoryDetailSummary())
}

export const fetchTaskCustomSearch = (
  param: RequestGetTaskCustomSearch,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  getTaskCustomSearch(param)
    .then((result: ResponseGetTaskCustomSearch) => {
      dispatch(buildTaskCustomSearch(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskGanttChartList = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskGanttChartList()
    .then((result: ResponseGetTaskGanttChartList) => {
      dispatch(buildTaskGanttChartList(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskGanttChart = (
  params: RequestGetTaskGanttChart,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  getTaskGanttChart(params)
    .then((result: ResponseGetTaskGanttChart) => {
      dispatch(buildTaskGanttChart(result))
      if (callback) callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskGanttChartDetail = (
  params: RequestGetTaskGanttChartDetail,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  getTaskGanttChartDetail(params)
    .then((result: ResponseGetTaskGanttChartDetail) => {
      dispatch(buildTaskGanttChartDetail(result))
      if (callback) callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskLabel = (
  param: RequestPatchTaskLabel,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskLabel(param)
    .then(() => {
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskCustomSearchNew = (
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskCustomSearchNew()
    .then((result: ResponseGetTaskCustomSearchNew) => {
      dispatch(buildTaskCustomSearchNew(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskLabelMember = (
  param: RequestPatchTaskLabelMember,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskLabelMember(param)
    .then(() => {
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskExcludeAutoLabelingTask = (
  param: RequestPostTaskExcludeAutoLabelingTask,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  postTaskExcludeAutoLabelingTask(param)
    .then((result: ResponsePostTaskExcludeAutoLabelingTask) => {
      dispatch(addTaskExcludeAutoLabelingTask(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskExcludeAutoLabelingTask = (
  param: RequestDeleteTaskExcludeAutoLabelingTask,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskExcludeAutoLabelingTask(param)
    .then(() => {
      dispatch(delTaskExcludeAutoLabelingTask(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskLabelMasterImport = (
  param: RequestPostTaskLabelMasterImport,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStartForModal())
  postTaskLabelMasterImport(param)
    .then((result: ResponsePostTaskLabelMasterImport) => {
      dispatch(addTaskLabelMasterImport(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskLabelGroupOrder = (
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskLabelGroupOrder()
    .then((result: ResponseGetTaskLabelGroupOrder) => {
      dispatch(buildTaskLabelGroupOrder(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskLearningScopeSetting = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskLearningScopeSetting()
    .then((result: ResponseGetTaskLearningScopeSetting) => {
      dispatch(buildTaskLearningScopeSetting(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskLearningScopeSetting = (
  param: RequestPatchTaskLearningScopeSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskLearningScopeSetting(param)
    .then(() => {
      dispatch(modTaskLearningScopeSetting(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskLabelGroupOrder = (
  param: RequestPatchTaskLabelGroupOrder,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(modTaskLabelGroupOrder(param))
  patchTaskLabelGroupOrder(param)
    .then(() => {
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
      dispatch(fetchTaskLabelGroupOrder())
    })
}

export const fetchTaskLabelingTargetModeSetting = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskLabelingTargetModeSetting()
    .then((result: ResponseGetTaskLabelingTargetModeSetting) => {
      dispatch(buildTaskLabelingTargetModeSetting(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskLabelingTargetModeSetting = (
  param: RequestPatchTaskLabelingTargetModeSetting,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskLabelingTargetModeSetting(param)
    .then(() => {
      dispatch(modTaskLabelingTargetModeSetting(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskCompanyServiceName = (
  callback?: () => void,
): AppThunk => async (dispatch) => {
  getTaskCompanyServiceName()
    .then((result: ResponseGetTaskCompanyServiceName) => {
      dispatch(buildTaskCompanyServiceName(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskCompanyServiceNameEdit = (
  param: RequestGetTaskCompanyServiceNameEdit,
  callback?: (result: ResponseGetTaskCompanyServiceNameEdit) => void,
): AppThunk => async (dispatch) => {
  getTaskCompanyServiceNameEdit(param)
    .then((result: ResponseGetTaskCompanyServiceNameEdit) => {
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskCompanyServiceName = (
  param: RequestPatchTaskCompanyServiceName,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskCompanyServiceName(param)
    .then(() => {
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const downloadCsvData = (
  code: string,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  getImportCsv()
    .then((response) => {
      const { data } = response
      if (code === 'Shift-JIS') {
        const reader = new FileReader()
        reader.onload = (e) => {
          if (e.target === null || e.target.result === null) return
          const encodeData = iconv.encode(e.target.result as string, "windows-31j")
          FileDownload(new Blob([encodeData]), `プロジェクト一括登録_${nowDate("YYYYMMDD")}.csv`)
        }
        reader.readAsText(data)
      } else {
        FileDownload(data, `プロジェクト一括登録_${nowDate("YYYYMMDD")}.csv`)
      }
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskBulkLabeling = (
  param: RequestGetTaskBulkLabeling,
  callback?: (result: ResponseGetTaskBulkLabeling) => void,
): AppThunk => async (dispatch) => {
  getTaskBulkLabeling(param)
    .then((result: ResponseGetTaskBulkLabeling) => {
      dispatch(buildTaskBulkLabeling(result))
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskBulkLabelingNew = (
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTaskBulkLabelingNew()
    .then((result: ResponseGetTaskBulkLabelingNew) => {
      dispatch(buildTaskBulkLabelingNew(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const createTaskBulkLabeling = (
  param: RequestPostTaskBulkLabeling,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  postTaskBulkLabeling(param)
    .then(() => {
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const destroyTaskBulkLabeling = (
  param: RequestDeleteTaskBulkLabeling,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  deleteTaskBulkLabeling(param)
    .then(() => {
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskNotWorkingRange = (
  param: RequestGetTaskNotWorkingRange,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  getTaskNotWorkingRange(param)
    .then((result: ResponseGetTaskNotWorkingRange) => {
      dispatch(buildTaskNotWorkingRanges(result))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updateTaskNotWorkingRange = (
  param: RequestPatchTaskNotWorkingRange,
  callback?: () => void,
): AppThunk => async (dispatch) => {
  patchTaskNotWorkingRange(param)
    .then(() => {
      dispatch(modTaskNotWorkingRanges(param))
      if (callback) {
        callback()
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskSearchLabelGroup = (
  param: RequestGetTaskSearchLabelGroup,
  callback?: (result: ResponseGetTaskSearchLabelGroup) => void,
): AppThunk => async (dispatch) => {
  getTaskSearchLabelGroup(param)
    .then((result: ResponseGetTaskSearchLabelGroup) => {
      dispatch(buildTaskSearchLabelGroup(result))
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskRecentlyUsedLabelGroup = (
  param: RequestGetTaskRecentlyUsedLabelGroup,
  callback?: (result: ResponseGetTaskRecentlyUsedLabelGroup) => void,
): AppThunk => async (dispatch) => {
  getTaskRecentlyUsedLabelGroup(param)
    .then((result: ResponseGetTaskRecentlyUsedLabelGroup) => {
      dispatch(buildTaskRecentlyUsedLabelGroup(result))
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskLabelGroupSummaries = (
  param: RequestGetTaskLabelGroupSummary,
  callback?: (result: ResponseGetTaskLabelGroupSummary) => void,
): AppThunk => async (dispatch) => {
  getTaskLabelGroupSummary(param)
    .then((result: ResponseGetTaskLabelGroupSummary) => {
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskViewableLabelGroup = (
  param: RequestGetTaskViewableLabelGroup,
  callback?: (result: ResponseGetTaskViewableLabelGroup) => void,
): AppThunk => async (dispatch) => {
  getTaskViewableLabelGroup(param)
    .then((result: ResponseGetTaskViewableLabelGroup) => {
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskViewableLabelGroupDetail = (
  param: RequestGetTaskViewableLabelGroupDetail,
  callback?: (result: ResponseGetTaskViewableLabelGroupDetail) => void,
): AppThunk => async (dispatch) => {
  getTaskViewableLabelGroupDetail(param)
    .then((result: ResponseGetTaskViewableLabelGroupDetail) => {
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskViewableLabelGroupMember = (
  param: RequestGetTaskViewableLabelGroupMember,
  callback?: (result: ResponseGetTaskViewableLabelGroupMember) => void,
): AppThunk => async (dispatch) => {
  getTaskViewableLabelGroupMember(param)
    .then((result: ResponseGetTaskViewableLabelGroupMember) => {
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTaskViewableLabelGroupTeam = (
  param: RequestGetTaskViewableLabelGroupTeam,
  callback?: (result: ResponseGetTaskViewableLabelGroupTeam) => void,
): AppThunk => async (dispatch) => {
  getTaskViewableLabelGroupTeam(param)
    .then((result: ResponseGetTaskViewableLabelGroupTeam) => {
      if (callback) {
        callback(result)
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}
